"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponents = void 0;
var accordion_1 = require("./accordion/accordion");
var accordion_summary_1 = require("./accordion/accordion-summary");
var badge_1 = require("./badge/badge");
var button_1 = require("./button/button");
var button_base_1 = require("./button/button-base");
var card_1 = require("./card/card");
var checkbox_1 = require("./checkbox/checkbox");
var chip_1 = require("./chip/chip");
var alert_1 = require("./feedback/alert");
var alert_title_1 = require("./feedback/alert-title");
var tooltip_1 = require("./feedback/tooltip");
var grid_1 = require("./grid/grid");
var autocomplete_1 = require("./input/autocomplete");
var filled_input_1 = require("./input/filled-input");
var standard_input_1 = require("./input/standard-input");
var input_adornment_1 = require("./input/input-adornment");
var form_control_label_1 = require("./form-control-label/form-control-label");
var input_label_1 = require("./input/input-label");
var outlined_input_1 = require("./input/outlined-input");
var radio_1 = require("./radio/radio");
var select_1 = require("./input/select");
var text_field_1 = require("./input/text-field");
var link_1 = require("./link/link");
var tab_1 = require("./tabs/tab");
var tabs_1 = require("./tabs/tabs");
var typography_1 = require("./typography/typography");
var divider_1 = require("./divider/divider");
var stepper_1 = require("./stepper/stepper");
var createComponents = function (theme) { return ({
    MuiAccordion: accordion_1.MuiAccordion,
    MuiAccordionSummary: (0, accordion_summary_1.createMuiAccordionSummary)(theme),
    MuiAlert: alert_1.MuiAlert,
    MuiAlertTitle: alert_title_1.MuiAlertTitle,
    MuiAutocomplete: autocomplete_1.MuiAutocomplete,
    MuiBadge: badge_1.MuiBadge,
    MuiButton: button_1.MuiButton,
    MuiButtonBase: button_base_1.MuiButtonBase,
    MuiCard: (0, card_1.createMuiCard)(theme),
    MuiCheckbox: checkbox_1.MuiCheckbox,
    MuiChip: chip_1.MuiChip,
    MuiDivider: divider_1.MuiDivider,
    MuiFilledInput: filled_input_1.MuiFilledInput,
    MuiFormControlLabel: form_control_label_1.MuiFormControlLabel,
    MuiGrid: grid_1.MuiGrid,
    MuiInput: standard_input_1.MuiInput,
    MuiInputAdornment: input_adornment_1.MuiInputAdornment,
    MuiInputLabel: input_label_1.MuiInputLabel,
    MuiLink: link_1.MuiLink,
    MuiOutlinedInput: outlined_input_1.MuiOutlinedInput,
    MuiRadio: radio_1.MuiRadio,
    MuiSelect: select_1.MuiSelect,
    MuiTabs: (0, tabs_1.createMuiTabs)(theme),
    MuiTab: (0, tab_1.createMuiTab)(theme),
    MuiTextField: text_field_1.MuiTextField,
    MuiTooltip: tooltip_1.MuiTooltip,
    MuiTypography: typography_1.MuiTypography,
    MuiStepper: stepper_1.MuiStepper,
}); };
exports.createComponents = createComponents;
//# sourceMappingURL=index.js.map